<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">角色添加</h1>
            <el-form class="form-container" :model="roleInfo" :rules="roleRules" ref="userInfoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">角色名称</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="name">
                            <el-input placeholder="请输入角色名称"  v-model="roleInfo.name">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">角色描述</span>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="description">
                            <el-input placeholder="请输入描述"  v-model="roleInfo.description">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">上级角色</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="up_role_id">
                            <el-select v-model="roleInfo.up_role_id" placeholder="请选择上级角色">
                                <el-option v-for="item in options" :key="item.id" :label="item.value" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('userInfoForm')">确 认</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    import { getRoleList, addRole } from '@/service/user'
    import {getUserInfo} from '@/utils/auth'
    import {validateChat} from '@/utils/validate'
    export default {
        name: "add",
        components: {
            PopoverRight
        },
        props: {
            callback: Function
        },
        data () {
            return {
                roleInfo: {
                    id : 0,
                    name: '',
                    description : '',
                    up_role_id : 0,
                },
                options : [],
                user : {},
                roleRules: {
                    name: [
                        { required: true, message: '请填写名称', trigger: 'blur' },
                        {validator:validateChat,type:4, trigger: 'blur',result:'角色名'},
                        { min: 2, max: 25, message: '长度在 2 到 25 个字符', trigger: 'blur' }
                    ],
                    up_role_id: [
                        { required: true, message: '请填写上级角色', trigger: 'blur' }
                    ],
                    description: [
                        { min: 6, max: 300, message: '长度在 6 到 300 个字符', trigger: 'blur' }
                    ],
                },
            }
        },
        methods : {
            async open () {
                this.user = JSON.parse(getUserInfo())
                let query = {
                    status : 0,
                    page : 1,
                    per_page : 100,
                }
                await getRoleList(query).then((data) => {
                    let listData = data.data
                    let arr1 = []
                    let arr2 = []
                    let if_push = false
                    for (let i in listData) {
                        let row = listData[i]
                        if (row.id == this.user.role_id) {
                            arr1.push({
                                id : row.id,
                                value : '当前角色',
                            })
                            if_push = true
                        } else {
                            arr2.push({
                                id : row.id,
                                value : row.name,
                            })
                        }
                    }
                    if (!if_push) {
                        arr1.push({
                            id : this.user.role_id,
                            value : '当前角色',
                        })
                    }
                    this.options = arr1.concat(arr2)
                    this.roleInfo.up_role_id = this.user.role_id
                })
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.resetForm();
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
                this.$refs.userInfoForm && this.$refs.userInfoForm.clearValidate()
            },
            resetForm () {
                this.roleInfo = {
                    id : 0,
                    name: '',
                    description : '',
                    up_role_id : 0,
                }
                this.user = {}
                this.options = []
            },
            submitForm (formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        let query = {
                            name:this.roleInfo.name,
                            description:this.roleInfo.description,
                            up_role_id:this.roleInfo.up_role_id,
                        }
                        addRole(query).then((data) => {
                            this.$message({
                                message: '添加成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.resetForm()
                            this.hide()
                            this.callback && this.callback()
                        }).catch(err => {
                            const message = err.context ? err.context[0] : err.message
                            this.$message({
                                message: message || '添加失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })

                    } else {
                        return false
                    }
                })
            },
        },
    }
</script>

<style scoped>

</style>
